import { useMemo } from "react";
import { getAccountPages } from "./useAccountNavigationConfig.helpers";

export const useAccountNavigationConfig = () => {
  return useMemo(() => getAccountPages(), []);
};
